import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const footerSections = [
    {
      title: 'Services',
      links: [
        { name: 'Web Hosting', href: '/hosting' },
        { name: 'Domain Names', href: '/domains' },
        { name: 'VPS Hosting', href: '/vps' },
        { name: 'Business Email', href: '/email' },
      ],
    },
    {
      title: 'Company',
      links: [
        { name: 'About Us', href: '/about' },
        { name: 'Contact', href: '/contact' },
      ],
    },
    {
      title: 'Support',
      links: [
        { name: 'Contact Support', href: '/contact' },
        { name: 'Sign In', href: '/login' },
      ],
    },
    {
      title: 'Legal',
      links: [
        { name: 'Terms of Service', href: '/terms' },
        { name: 'Privacy Policy', href: '/privacy' },
        { name: 'Acceptable Use', href: '/aup' },
        { name: 'Refund Policy', href: '/refund' },
        { name: 'Service Level Agreement', href: '/sla' },
        { name: 'Cookie Policy', href: '/cookies' },
      ],
    },
  ];

  return (
    <footer className="bg-primary-navy text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center mb-6">
              <img src="/logo-icon.svg" alt="12and22" className="w-8 h-8 mr-3" />

              <span className="text-2xl font-bold">12and22</span>
            </Link>
            
            <p className="text-gray-300 text-sm mb-4">
              Reliable hosting solutions for businesses of all sizes. From shared hosting to enterprise VPS,
              we've got you covered.
            </p>
          </div>

          {/* Footer Links */}
          {footerSections.map((section, index) => (
            <div key={index}>
              <h3 className="text-lg font-semibold mb-4">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link
                      to={link.href}
                      className="text-gray-300 hover:text-secondary-500 transition-colors duration-200 text-sm"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-300 text-sm">
            © {currentYear} SIVRA Inc. 12and22 is a product of SIVRA Inc. All rights reserved.
          </p>
          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <span className="text-gray-300 text-sm">24/7 Support</span>
            <Link to="/sla" className="text-gray-300 hover:text-secondary-500 text-sm transition-colors duration-200">99.9% Uptime SLA</Link>
            <Link to="/refund" className="text-gray-300 hover:text-secondary-500 text-sm transition-colors duration-200">14-Day Money Back</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;